const facebookAppId = import.meta.env.VITE_INSTAGRAM_APP_ID || "886020493843840";

export function initFacebookSdk() {
    return new Promise((resolve, reject) => {
        // Configurar fbAsyncInit
        window.fbAsyncInit = function () {
            FB.init({
                appId: facebookAppId,
                cookie: true,
                xfbml: true,
                version: "v21.0",
            });

            // Verifica se a página está em HTTPS antes de chamar getLoginStatus
            if (window.location.protocol === 'https:') {
                // Verifica o status do SDK apenas em HTTPS
                FB.getLoginStatus(
                    (response) => {
                        console.log("Facebook SDK inicializado:", response);
                        resolve(response);
                    },
                    (error) => {
                        console.error("Erro ao inicializar o Facebook SDK:", error);
                        reject(error);
                    }
                );
            } else {
                // Em HTTP, simplesmente resolve sem verificar o status
                console.log("Facebook SDK inicializado em HTTP (getLoginStatus não disponível)");
                resolve({ status: 'unknown', authResponse: null });
            }
        };

        // Carregar o SDK dinamicamente
        (function (d, s, id) {
            const js = d.createElement(s),
                fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) {
                return;
            }
            js.id = id;
            js.src = "https://connect.facebook.net/en_US/sdk.js";
            fjs.parentNode.insertBefore(js, fjs);
        })(document, "script", "facebook-jssdk");
    });
}
